module.exports = __webpack_public_path__ + "img/dsci0141.18301e07.jpg";